import { HashTable } from './HashTable.js';
import { Dictionary } from './Dictionary.js';
import { isDefined } from '../utils/functions.js';
import { Observable } from '../utils/Observable.js';

/**
 * While other data structures can have multiple times the same item a Set owns only
 * once a particular item.
 *
 * @type {*}
 */
class Set extends Observable {
    constructor(resource) {
        super();
        this._hashTable = new HashTable();
        this.length = 0;
        if (isDefined(resource)) {
            if (resource instanceof HashTable) {
                resource.forEach(function (d) {
                    this.add(d);
                });
            }
            else if (resource instanceof Dictionary) {
                resource.forEach(function (k, v) {
                    this.add({ key: k, value: v });
                }, this);
            }
        }
    }
    contains(item) {
        return this._hashTable.containsKey(item);
    }
    add(item) {
        const entry = this._hashTable.get(item);
        if (!entry) {
            this._hashTable.add(item, item);
            this.length++;
            this.trigger('changed');
        }
    }
    get(item) {
        if (this.contains(item)) {
            return this._hashTable.get(item).value;
        }
        else {
            return null;
        }
    }
    /**
     * Returns the hash of the item.
     *
     * @param item
     * @returns {*}
     */
    hash(item) {
        return this._hashTable._hash(item);
    }
    /**
     * Removes the given item from the set. No exception is thrown if the item is not in the Set.
     *
     * @param item
     */
    remove(item) {
        if (this.contains(item)) {
            this._hashTable.remove(item);
            this.length--;
            this.trigger('changed');
        }
    }
    /**
     * Foreach with an iterator working on the key-value pairs.
     *
     * @param func
     */
    forEach(func, context) {
        const call = context ? func.bind(context) : func;
        this._hashTable.forEach(function (kv) {
            call(kv.value);
        });
    }
    toArray() {
        const r = [];
        this.forEach(function (d) {
            r.push(d);
        });
        return r;
    }
}

export { Set };
